const TutorialSections = {
    BEFORE_LOGIN: 1, // Request to login
    WELCOME: 2, // Simple tutorial
    MAP: 3, // Explain about the map    
}
const SectionDetails = {};
SectionDetails[TutorialSections.BEFORE_LOGIN] = {
    phases: [
        {"text": "Welcome to Meow Playground, where your virtual adventure begins!"},
        {"text": "Please Log-In from the top-right corner of the screen to continue the tutorial", "mark": "login"}
    ]
}
SectionDetails[TutorialSections.WELCOME] = {
    phases: [
        {"text": "You're now a citizen of Meow Town!",},
        {"text": "You can change your name from the settings window", "mark": "settings"},
        {"text": "To play games with other Meow Citizens, join a game queue", "mark": "games"},
        {"text": "Right click an empty spot to open the actions menu"},
        {"text": "Double click to run"},
        {"text": "Start your adventure by exploring the Meow Town", "mark": "town"},
        {"text": "You can access the full tutorial here. Have Fun!", "mark": "tutorial"},
    ]
}
/*
    Server saves a row for each section with info about current Phase
*/
export default {
    namespaced: true,
    state: {
        data: {
            isActive: false,
            sections: TutorialSections,
            sectionDetails: SectionDetails,
            section: TutorialSections.WELCOME,
            phase: 0
        },
    },
    getters: {
        currentMark(state){
            return state.data.sectionDetails[state.data.section].phases[state.data.phase].mark;
        },
        data(state) {return state.data;},
        getValue: (state) => (parameter) => {
            return state[parameter];
        },
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        setRoomTutorial(state, data){
            if(!data){
                state.data.isActive = false;
            }
            else if(data.phase === -1){
                state.data.isActive = true;
                state.data.section = data.section;
                state.data.phase = 0;
            } else if (data.phase >= state.data.sectionDetails[data.section].phases.length -1){
                state.data.isActive = false;
            } else {
                state.data.isActive = true;
                state.data.section = data.section;
                state.data.phase = data.phase+1;
            }
        }
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        setRoomTutorial({ commit }, data) {
            commit('setRoomTutorial', data);
        },
    }
};